import { Container } from "react-grid-system";
import styled from "styled-components";
import theme from "themes/simple-theme";

export const FormContainer = styled(Container)`
  min-width: 720px;
`;



// WEBPACK FOOTER //
// ./src/components/common/Form/FormContainer.tsx